import { render, staticRenderFns } from "./MemberNew.vue?vue&type=template&id=42f65647&scoped=true&"
import script from "./MemberNew.vue?vue&type=script&lang=js&"
export * from "./MemberNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberNew.vue?vue&type=style&index=0&id=42f65647&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f65647",
  null
  
)

export default component.exports